"use client";

import { Send, X, MessageCircle, Loader2 } from "lucide-react";

export interface AgentChatActionButtonsProps {
    hasText: boolean;
    isMultiLine?: boolean;
    isLoading?: boolean;
    disabled?: boolean;
    voiceButton?: React.ReactNode;
    onCollapse: () => void;
}

/**
 * Action toolbar component supporting both inline single-line cluster
 * and full-width multi-line bottom toolbar with AI status badge and voice control.
 */
export const AgentChatActionButtons: React.FC<AgentChatActionButtonsProps> = ({
    hasText,
    isMultiLine = false,
    isLoading = false,
    disabled = false,
    voiceButton,
    onCollapse,
}) => {
    const buttonsCluster = (
        <div className="flex items-center gap-1 sm:gap-1.5 shrink-0 mr-0.5">

            <button
                type="submit"
                disabled={!hasText || isLoading || disabled}
                title="Gửi câu hỏi (Enter)"
                className="flex h-7 w-7 sm:h-8 sm:w-8 items-center justify-center rounded-full bg-[#5FCD6F] hover:bg-[#4eb75e] disabled:bg-white/10 disabled:text-gray-500 disabled:opacity-40 disabled:cursor-not-allowed text-white transition-all shadow-md active:scale-95 cursor-pointer"
            >
                <Send className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
            </button>

            <button
                type="button"
                onClick={onCollapse}
                title="Đóng khung chat (Thu gọn)"
                className="flex h-7 w-7 sm:h-8 sm:w-8 items-center justify-center rounded-full text-slate-400 hover:text-white hover:bg-white/10 active:scale-95 transition-all cursor-pointer"
            >
                <X className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
            </button>
        </div>
    );

    if (!isMultiLine) {
        return buttonsCluster;
    }

    return (
        <div className="flex items-center justify-between pt-1.5 border-t border-white/10">
            <div className="flex items-center gap-2 text-xs text-slate-300 font-medium select-none ml-0.5">
                {voiceButton}
                <div className="flex items-center gap-1.5">
                    <div className="flex h-5 w-5 items-center justify-center rounded-full bg-gradient-to-tr from-[#16a34a] via-[#22c55e] to-[#4ade80] text-white shadow-xs">
                        {isLoading ? (
                            <Loader2 className="h-3 w-3 animate-spin text-white" />
                        ) : (
                            <MessageCircle className="h-3 w-3 text-white fill-white" />
                        )}
                    </div>
                    <span className="text-[11px] text-slate-300">Nhắn tin AI</span>
                </div>
            </div>

            {buttonsCluster}
        </div>
    );
};

export default AgentChatActionButtons;
